import { render, staticRenderFns } from "./PenyelesaianUsulan.vue?vue&type=template&id=7a942382&lang=pug&"
import script from "./PenyelesaianUsulan.vue?vue&type=script&lang=js&"
export * from "./PenyelesaianUsulan.vue?vue&type=script&lang=js&"
import style0 from "./PenyelesaianUsulan.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports